import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./baseQuery";

// Dummy API (JSONPlaceholder)
const apiUrl = process.env.REACT_APP_API_URL;
export const profileApi = createApi({
  reducerPath: "profileApi", // optional, defaults to 'api'
  baseQuery: customBaseQuery,
  tagTypes: ["profileDetails"],
  endpoints: (builder) => ({
    updateUserProfile: builder.mutation({
      query: (data) => {
        return {
          url: `/user/profile`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["profileDetails"], // GET /posts
    }),
    updateUserTradeRefernce: builder.mutation({
      query: (data) => {
        return {
          url: `/user/trade-reference`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["profileDetails"], // GET /posts
    }),

    getProfileDdetail: builder.query({
      query: () => {
        return {
          url: "/user/profile",
          method: "GET",
        };
      },
      transformResponse: (res) => {
        return res.data;
      },
      providesTags: ["cartList"],
    }),
    getUserInquiryList: builder.query({
      query: (page) => {
        return {
          url: `/user/inquiry/list?pageNumber=${page}&pageSize=10`,
          method: "GET",
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
    }),
    getInquirySummaryDetailsList: builder.query({
      query: (id) => {
        return {
          url: `/user/inquiry/summary?inquiryId=${id}`,
          method: "GET",
        };
      },
    }),
    getCountryList: builder.query({
      query: (id) => {
        return {
          url: `/country/list`,
          method: "GET",
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
    }),
    getStateList: builder.query({
      query: (id) => {
        return {
          url: `/country/state/list?countryId=${id}`,
          method: "GET",
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
    }),
    sendCntactus: builder.mutation({
      query: (data) => {
        return {
          url: `/contact/request`,
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const {
  useGetProfileDdetailQuery,
  useUpdateUserProfileMutation,
  useUpdateUserTradeRefernceMutation,
  useGetInquirySummaryDetailsListQuery,
  useGetUserInquiryListQuery,
  useGetCountryListQuery,
  useGetStateListQuery,
  useSendCntactusMutation,
} = profileApi;
